import {BitrixVue} from "ui.vue3";
import MapComponent from "./components/MapComponent";
export class PartnersMapV2 {
	application;
	params;
	constructor(rootNode, params) {
		this.rootNode = document.querySelector(rootNode);
		this.params = JSON.parse(JSON.stringify(params));
		this.attachTemplate();
	}
	
	attachTemplate() {
		if (!this.rootNode) return;
		
		this.application = BitrixVue.createApp(MapComponent, {
			params: this.params
		});
		this.application.mount(this.rootNode)
	}
}
